<template>
<div >
  <div class="row no-print">
        <div class=" no-print flex xs12 sm12 lg9">
          <h1>{{ $t('gestaopessoas.Alunos') }}</h1>
        </div>
        <div class="flex xs12 sm12 lg3">
          <!-- <va-button class="text-right" @click="abrirNovo()"  :color="BuNovo.color" :style="BuNovo"> INFORME</va-button> -->
        </div>
  </div>

<div class="" >

              <div class="row">
                 <div class="flex md3 sm12 xs12">
                  <va-input
                    label="Fecha"
                    v-model="busca.data_inicio"
                    type="date"
                   
                  />
                </div>
                <div class="flex md3 sm12 xs12">
                  <va-input
                    label="Fecha"
                    v-model="busca.data_fim"
                    type="date"
                    
                  />
                </div>

                 <div class="flex md3 sm12 xs12">
                    <va-select
                      label="Polo"
                      v-model="polo"
                      textBy="nome"
                      :options="allPolos"
                      
                    />
                  </div>
                  <div class="flex md3 sm12 xs12">
                    <va-button class="text-right" @click="buscar_alunos()"  color="dark" :style="BuNovo"> Buscar</va-button>

                  </div>

              </div>
              

</div>

 <div class="no-print" v-if="novo">
          <!-- <form @submit.prevent="addNovo()"> -->
            
             <h5>Dados pessoais</h5>
              <hr>
              <div class="row">
                <div class="flex md3 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="aluno.nome"
                    placeholder="Nombre "
                  />
                </div>

                <div class="flex md4 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="aluno.sobrenome"
                    placeholder="Apelido"
                  />
                </div>
                <div class="flex md3 sm12 xs12">
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="aluno.tipo_documento"
                      textBy="nome"
                      :options="allTipoDocumento"
                      placeholder="Tipo documento"
                    />
                  </div>
                <div class="flex md2 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="aluno.doc_oficial"
                    placeholder="Documento"
                  />
                </div>
              </div>
            
              <div class="row">
                <div class="flex md3 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="aluno.telefone"
                    placeholder="Telefone"
                  />
                </div>
                <div class="flex md3 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="aluno.celular"
                    placeholder="Celular"
                  />
                </div>
                 

                  <div class="flex md3 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="aluno.email"
                    type="email"
                    placeholder="Email"
                    :error="!!emailErrors.length"
                    :error-messages="emailErrors"
                  />
                </div>
                 <div class="flex md3 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="aluno.data_nascimento"
                    type="date"
                    placeholder="Data de nascimento"
                  />
                </div>
              </div>
              <div class="row">
                <div class="flex md3 sm12 xs12">
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="aluno.profissao"
                      textBy="nome"
                      :options="allProfissao"
                      placeholder="Profissao"
                    />
                  </div>
                  <div class="flex md3 sm12 xs12">
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="aluno.escolaridade"
                      textBy="nome"
                      :options="allEscolaridade"
                      placeholder="Escolaridade"
                    />
                  </div>
                
                  <div class="flex md3 sm12 xs12">
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="aluno.sexo"
                      textBy="nome"
                      :options="allSexo"
                      placeholder="Sexo"
                    />
                  </div>
                  <div class="flex md3 sm12 xs12">
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="aluno.estado_civil"
                      textBy="nome"
                      :options="allEstadoCivil"
                      placeholder="Estado civil"
                    />
                  </div>

              </div>

               <h5>Endereço</h5>
              <hr>

              <div class="row">
                <div class="flex md3 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="aluno.endereco"
                    placeholder="Calle"
                  />
                </div>

                <div class="flex md3 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="aluno.numero"
                    placeholder="Numero"
                  />
                </div>
                <div class="flex md3 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="aluno.bairro"
                    placeholder="Barrio"
                  />
                </div>
                <div class="flex md3 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="aluno.cep"
                    placeholder="CEP"
                  />
                </div>

                  
              </div>
            
              
           
              <div class="row text-center">
                
                 <div class="flex md12 sm12 xs12 ">
                    <va-button class="text-center"  @click="novo =  false"  color="danger"> Cerrar </va-button>
                </div>

              </div>
              
          <!-- </form> -->

  </div> 
 
    <va-data-table
          class="print"
          :fields="fields"
          :data="allAlunos"
          hoverable
          no-pagination
          >
              <template slot="marker" slot-scope="props">
                <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
              </template>

              <template class="no-print" slot="actions" slot-scope="props">
                <va-button flat small color="info" @click="ver_dados_aluno(props.rowData)" class="ma-0">
                    Ver
                </va-button>
                <va-button flat small color="info" @click="financeiro_aluno(props.rowData)" class="ma-0">
                    {{ $t('arealuno.Financeiro') }}
                </va-button>

                <va-button flat small color="primary" @click="abrirMatriculaAluno(props.rowData)" class="ma-0">
                  {{ $t('arealuno.Matriculas') }}
                </va-button>

                <va-button flat small color="danger" @click="remove(props.rowData)" class="ma-0">
                  {{ $t('tables.delete') }}
                </va-button>
              </template>
              
        </va-data-table>

</div>

      
 
</template>

<script>

export default {
  name: 'alunos',
  
  
  data () {
      return {

        busca:{
          data_inicio: '',
          data_fim: '',
          polo_id:''

        },
        polo:'',
        
        BuNovo: {
          color:'success',
          'width': '100%',
        }, 
        novo: false,

        cidade_naturalidade:[],
        cidade_endereco:[],
   
        aluno:{
          nome:'',
          sobrenome:'',
          tipo_documento:'',
          doc_oficial:'',
          telefone:'',
          celular:'',
          email:'',
          data_nascimento:'',
          profissao:'',
          escolaridade:'',
          sexo:'',
          estado_civil:'',
          endereco:'',
          numero:'',
          bairro:'',
          cep:'',
          cidade:'',
          pais:'',
          naturalidade:'',
          perfil_id: '2',
          pais_naturalidade: {
            id:'',
          },
          estado_naturalidade:{
            id:'',
          },
          pais_endereco: {
            id:'',
          },
          estado_endereco:{
            id:'',
          },

        },
        cidade:[],
        estado:[],
        pais:[],

        emailErrors: [],
     
      }
    },
    created(){
     this.$store.dispatch('allAlunos')
     this.$store.dispatch('allPolo')
    },
  computed: {
    
    allPolos(){ return   this.$store.state.polos.allpolos},
    allTipoDocumento(){ return   this.$store.state.tipos.tipo_documento},
    allProfissao(){ return   this.$store.state.tipos.profissao},
    allEscolaridade(){ return   this.$store.state.tipos.escolaridade},
    allSexo(){ return   this.$store.state.tipos.sexo},
    allEstadoCivil(){ return   this.$store.state.tipos.estado_civil},
    allPais(){ return   this.$store.state.tipos.pais},
    allAlunos(){ return   this.$store.state.alunos.allalunos},
   

    AllEstadoNaturalidade(){ 
        if (this.aluno.pais_naturalidade.id != '') {
          this.$store.dispatch('GetEstadoNaturalidade',this.aluno.pais_naturalidade.id)
          this.aluno.pais_naturalidade.id = ''
        
        }
        return this.$store.state.tipos.estado_naturalidade 
    },
    AllCidadeNaturalidade(){ 
        if (this.aluno.estado_naturalidade.id != '') {
          this.$store.dispatch('GetCidadeNaturalidade',this.aluno.estado_naturalidade.id)
          this.aluno.estado_naturalidade.id = ''
        
        }
        return this.$store.state.tipos.cidade_naturalidade 
    },
    AllEstadoEndereco(){ 
        if (this.aluno.pais_endereco.id != '') {
          this.$store.dispatch('GetEstadoEndereco',this.aluno.pais_endereco.id)
          this.aluno.pais_endereco.id = ''
        
        }
        return this.$store.state.tipos.estado_endereco
    },
    AllCidadeEndereco(){ 
        if (this.aluno.estado_endereco.id != '') {
          this.$store.dispatch('GetCidadeEndereco',this.aluno.estado_endereco.id)
          this.aluno.estado_endereco.id = ''
        }
        return this.$store.state.tipos.cidade_endereco
    },
  
   
    
    fields () {
        return [{
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        }, {
          name:'nome',
          title: this.$t('tables.headings.name'),
        },{
          name:'nome_polo',
          title: 'Polo',
        }, {
          name: 'email',
          title: this.$t('tables.headings.email'),
        }, {
          name: 'acion',
          dataClass: 'text-center',
          
         
        }, {
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
    },
  formReady () {
      return !this.emailErrors.length
    },
         
  },

  methods: {

    ver_dados_aluno(value){

    this.aluno =  value
      this.novo = true

    },

    buscar_alunos(){
      let dados = {}
        dados = {
          data_inicio: this.busca.data_inicio,
          data_fim: this.busca.data_fim,
          polo_id: this.polo.id

        }
        //console.log(dados)
       this.$store.dispatch('buscar_alunos',dados)
    },
    buscar_tipos(){
      this.$store.dispatch('allTipoDocumento')
      this.$store.dispatch('allProfissao')
      this.$store.dispatch('allEscolaridade')
      this.$store.dispatch('allSexo')
      this.$store.dispatch('allEstadoCivil')
      this.$store.dispatch('allPais')
      this.$store.dispatch('allAlunos')
      this.$store.dispatch('allPolo')
       
    },
    async financeiro_aluno (value) {
     
      this.$store.dispatch('getAluno',value);
      this.$emit('trocar_component', 'financeiroaluno');
      
        },
    async abrirMatriculaAluno (value) {
     
      this.$store.dispatch('getAluno',value);
      this.$emit('trocar_component', 'matriculaaluno');
      
    },

    abrirNovo (){
      this.novo = !this.novo
      this.buscar_tipos()
    },
    addNovo (){
    
    this.emailErrors = this.aluno.email ? [] : ['Email é obrigatório']
    
      if (!this.formReady) {
        return
      }
    this.$store.dispatch('AddAlunos',this.aluno)
    this.abrirNovo()
    this.buscar_tipos()
    },
 
  },
}
</script>

<style lang="scss" scoped>

</style>
